/* eslint-disable react-hooks/exhaustive-deps */
import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import { UtilService } from "../../../../services";

import { MFAssetsTypesOptions } from "../../../../config/filingConstants";
import { IMutualFundForm } from "../../../../config/interfaces";
import { FormField, NumericInputField, SelectInputField, TextInputField } from "../../../fields";

type Props = {};

const CGMutualFundForm: React.FC<Props> = (props: Props) => {
	const {} = props;

	const { values, errors, touched, setFieldValue, handleBlur } =
		useFormikContext<IMutualFundForm>();

	useEffect(() => {
		const _TotalSale = Number(values?.NetSalePrice || 0) - Number(values.TransferExpense || 0);
		setFieldValue("TotalSalePrice", _TotalSale);
		const _CapitalGain = _TotalSale - Number(values?.TotalPurchasePrice || 0);
		setFieldValue("CapitalGains", _CapitalGain);
	}, [values?.TotalPurchasePrice, values?.NetSalePrice, values.TransferExpense]);

	return (
		<>
			<section className="mb-5">
				<FormField label="Type of Assets" isRequired={true} sm={4}>
					<SelectInputField
						placeholder="Type of Assets"
						name="TypeAssets"
						options={UtilService.convertToArray(MFAssetsTypesOptions)}
						value={
							values.TypeAssets
								? [{ label: MFAssetsTypesOptions[values.TypeAssets], value: values.TypeAssets }]
								: undefined
						}
						onChange={(_selectedTypesAssets) => {
							if (_selectedTypesAssets) {
								setFieldValue("TypeAssets", _selectedTypesAssets.value);
							} else {
								setFieldValue("TypeAssets", undefined);
							}
						}}
						onBlur={handleBlur("TypeAssets")}
						isInvalid={Boolean(errors.TypeAssets) && touched.TypeAssets}
						errorMsg={errors.TypeAssets}
					/>
				</FormField>

				<FormField label="STT Paid" isRequired={true} sm={4}>
					<SelectInputField
						placeholder="STT Paid"
						name="STTPaid"
						isOptionArrayOfObject={false}
						options={["Yes", "No"]}
						value={[values.STTPaid]}
						onChange={(_STTPaid) => {
							if (_STTPaid) {
								setFieldValue("STTPaid", _STTPaid.value);
							} else {
								setFieldValue("STTPaid", undefined);
							}
						}}
						onBlur={handleBlur("STTPaid")}
						isInvalid={Boolean(errors.STTPaid) && touched.STTPaid}
						errorMsg={errors.STTPaid}
					/>
				</FormField>

				<FormField label="Description of asset sold" isRequired={true} sm={4}>
					<TextInputField
						name="DescriptionAssetSold"
						value={values.DescriptionAssetSold}
						onChange={(value) => {
							setFieldValue("DescriptionAssetSold", value);
						}}
						onBlur={(e) => {
							handleBlur(e);
							setFieldValue("DescriptionAssetSold", values.DescriptionAssetSold.trim());
						}}
						isInvalid={Boolean(errors.DescriptionAssetSold) && touched.DescriptionAssetSold}
						errorMsg={errors.DescriptionAssetSold}
					/>
				</FormField>

				<FormField label="Net Sale Price" isRequired={true} sm={4}>
					<NumericInputField
						showLeftIcon={true}
						placeholder=""
						name="NetSalePrice"
						value={values.NetSalePrice}
						onChange={(value) => {
							setFieldValue("NetSalePrice", value);
						}}
						onBlur={handleBlur("NetSalePrice")}
						isInvalid={Boolean(errors.NetSalePrice) && touched.NetSalePrice}
						errorMsg={errors.NetSalePrice}
					/>
				</FormField>

				<FormField label="Transfer Expenses" isRequired={true} sm={4}>
					<NumericInputField
						showLeftIcon={true}
						name="TransferExpense"
						value={values.TransferExpense}
						onChange={(value) => {
							setFieldValue("TransferExpense", value);
						}}
						onBlur={handleBlur("TransferExpense")}
						isInvalid={Boolean(errors.TransferExpense) && touched.TransferExpense}
						errorMsg={errors.TransferExpense}
					/>
				</FormField>

				<FormField label="Total Sale Price" sm={4}>
					<NumericInputField
						showLeftIcon={true}
						placeholder=""
						name="TotalSalePrice"
						value={values.TotalSalePrice}
						onChange={(value) => {
							setFieldValue("TotalSalePrice", value);
						}}
						onBlur={handleBlur("TotalSalePrice")}
						isInvalid={Boolean(errors.TotalSalePrice) && touched.TotalSalePrice}
						errorMsg={errors.TotalSalePrice}
						isDisabled={true}
					/>
				</FormField>

				<FormField label="Total Fair Market Value" isRequired={true} sm={4}>
					<NumericInputField
						showLeftIcon={true}
						placeholder=""
						name="TotalFairMarketValue"
						value={values.TotalFairMarketValue}
						onChange={(value) => {
							setFieldValue("TotalFairMarketValue", value);
						}}
						onBlur={handleBlur("TotalFairMarketValue")}
						isInvalid={Boolean(errors.TotalFairMarketValue) && touched.TotalFairMarketValue}
						errorMsg={errors.TotalFairMarketValue}
					/>
				</FormField>

				<FormField label="Total Purchase Price" isRequired={true} sm={4}>
					<NumericInputField
						showLeftIcon={true}
						placeholder=""
						name="TotalPurchasePrice"
						value={values.TotalPurchasePrice}
						onChange={(value) => {
							setFieldValue("TotalPurchasePrice", value);
						}}
						onBlur={handleBlur("TotalPurchasePrice")}
						isInvalid={Boolean(errors.TotalPurchasePrice) && touched.TotalPurchasePrice}
						errorMsg={errors.TotalPurchasePrice}
					/>
				</FormField>

				<FormField label="Capital Gain/(loss)" sm={4}>
					<NumericInputField
						showLeftIcon={true}
						placeholder=""
						allowNegative={true}
						name="CapitalGains"
						value={values.CapitalGains}
						onChange={(value) => setFieldValue("CapitalGains", value)}
						onBlur={handleBlur("CapitalGains")}
						isInvalid={Boolean(errors.CapitalGains) && touched.CapitalGains}
						errorMsg={errors.CapitalGains}
						isDisabled={true}
					/>
				</FormField>
			</section>
		</>
	);
};

export default CGMutualFundForm;
